import React from "react";
import { X } from "lucide-react";
import "../styles/DatePanel.css";
import { ymdUTC } from "../utils/date";

const getStatusIcon = (s) => (s >= 80 ? "✅" : s >= 60 ? "⚠️" : "❌");

/* graceful formatter ------------------------------------------ */
const fmt = (n, digits = 1, unit = "") =>
  typeof n === "number" && !Number.isNaN(n) ? `${n.toFixed(digits)}${unit}` : "—";

export default function DatePanel({ matches, selectedDates, onClear }) {
  const buildRows = (m) => [
    { label: "Overall",      val: m.overall_score != null ? `${m.overall_score}%` : "—", s: m.overall_score },
    { label: "Temperature",  val: fmt(m.temp_f        ?? m.temperature,       1,  " °F"),  s: m.temperature_score     },
    { label: "Humidity",     val: fmt(m.humidity_raw  ?? m.humidity,          0,  " %"),   s: m.humidity_score        },
    { label: "Sun / Clouds", val: fmt(m.sunlight_raw  ?? m.cloud,             0,  " W"),   s: m.sunClouds_score       },
    { label: "Wind",         val: fmt(m.wind_raw      ?? m.windSpeed,         1,  " mph"), s: m.wind_score            },
    { label: "Rain",         val: fmt(m.precip_raw    ?? (m.precip_mm/25.4),  2,  " in"),  s: m.precipitation_score   },
    { label: "Sunset",       val: m.sunset_raw ?? m.sunset ?? "—",                    s: m.sunset_score          },
  ];

  return (
    <aside className="selected-detail-panel">
      {selectedDates.map((fd) => {
        const m = matches.find((x) => x.forecast_date === fd);
        if (!m) return null;
        return (
          <div key={fd} className="date-detail-card">
            <header>
              <span>{ymdUTC(fd)}</span>
              <button className="clear-btn" onClick={() => onClear(m)}>
                <X size={16} />
              </button>
            </header>
            <ul>
              {buildRows(m).map(({ label, val, s }) => (
                <li key={label}>
                  <span className="stat-label">{label}</span>
                  <span className="stat-val">{val}</span>
                  <span className="stat-status">{getStatusIcon(s)}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </aside>
  );
}